import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon, MenuIcon, SearchIcon, ShoppingBagIcon } from "lucide-react";
import { Logo } from "./Logo";
import { MegaMenu } from "./MegaMenu";
import { MobileMenu } from "./MobileMenu";
import { useCart } from "../contexts/CartContext";
import { mainNav } from "../data/navigation";
import { container, ease } from "../utils/styles";
interface HeaderProps {
  onSearch: () => void;
}
export function Header({
  onSearch
}: HeaderProps) {
  const {
    count,
    open
  } = useCart();
  const [mega, setMega] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const current = location.pathname + location.search;
  useEffect(() => {
    setMega(false);
    setMenuOpen(false);
  }, [location.pathname, location.search]);
  const linkClass = "relative flex h-[72px] items-center text-sm text-ink/80 transition-colors duration-150 hover:text-ink";
  return <header className="sticky top-0 z-40 border-b border-line bg-paper/95 backdrop-blur-md" onMouseLeave={() => setMega(false)} data-id="element-101" data-mp="2wirozovg8nrj">
      <div className={`${container} grid h-[72px] grid-cols-[1fr_auto_1fr] items-center`} data-id="element-102" data-mp="2mmeu4no643v7">
        <div className="flex items-center" data-id="element-103" data-mp="2hntuoqgqpo7t">
          <button type="button" onClick={() => setMenuOpen(true)} className="-ml-2 flex h-10 w-10 items-center justify-center lg:hidden" aria-label="Menu openen" data-id="element-104" data-mp="2hovgnpzanv4b">
            <MenuIcon className="h-5 w-5" data-id="element-105" data-mp="3abpp1oiu741f" />
          </button>
          <nav aria-label="Hoofdnavigatie" className="hidden lg:block" data-id="element-106" data-mp="3aec6cfvj4xwu">
            <ul className="flex items-center gap-8" data-id="element-107" data-mp="35k7wnouvqbs2">
              <li onMouseEnter={() => setMega(true)} data-id="element-108" data-mp="30mpmxw91fsj0">
                <button type="button" onClick={() => setMega(m => !m)} aria-expanded={mega} className={`${linkClass} gap-1 ${mega ? "text-ink" : ""}`} data-id="element-109" data-mp="30lwn7f8hy3ad">
                  Shop
                  <ChevronDownIcon className={`h-3.5 w-3.5 transition-transform duration-200 ease-out ${mega ? "rotate-180" : ""}`} data-id="element-110" data-mp="3ta28c33gpuaq" />
                </button>
              </li>
              {mainNav.map(item => {
              const active = current === item.to;
              return <li key={item.label} onMouseEnter={() => setMega(false)} data-id="element-111" data-mp="1hmqh3blwugdj">
                    <Link to={item.to} className={`${linkClass} ${active ? "text-ink" : ""}`} data-id="element-112" data-mp="1mmbdbe9p4amk">
                      {item.label}
                      {active && <motion.span layoutId="nav-underline" className="absolute inset-x-0 bottom-0 h-0.5 bg-ink" transition={{
                    duration: 0.25,
                    ease
                  }} data-id="element-113" data-mp="18lijkvr7xjki" />}
                    </Link>
                  </li>;
            })}
            </ul>
          </nav>
        </div>

        <Link to="/" aria-label="Koers Design home" onMouseEnter={() => setMega(false)} data-id="element-114" data-mp="13p1sptsmwr3q">
          <Logo data-id="element-115" data-mp="2t2nd1js620k9" />
        </Link>

        <div className="flex items-center justify-end gap-1" onMouseEnter={() => setMega(false)} data-id="element-116" data-mp="2t3q53v18691r">
          <button type="button" onClick={onSearch} className="flex h-10 items-center gap-2 rounded-full px-3 text-sm text-ink/80 transition-colors duration-150 hover:bg-sand hover:text-ink" aria-label="Zoeken" data-id="element-117" data-mp="2y18grt6mn2dg">
            <SearchIcon className="h-[18px] w-[18px]" data-id="element-118" data-mp="hdgzb9jp2mgv" />
            <span className="hidden xl:inline" data-id="element-119" data-mp="w5j4980mg5nr">Zoeken</span>
          </button>
          <button type="button" onClick={open} className="relative flex h-10 w-10 items-center justify-center rounded-full transition-colors duration-150 hover:bg-sand" aria-label={`Winkelwagen, ${count} items`} data-id="element-120" data-mp="rd7tfa4cezgf">
            <ShoppingBagIcon className="h-[18px] w-[18px]" data-id="element-121" data-mp="106ukwo1ipgjt" />
            <AnimatePresence data-id="element-122" data-mp="108fjqpuv7lnh">
              {count > 0 && <motion.span key={count} initial={{
              scale: 0.6,
              opacity: 0
            }} animate={{
              scale: 1,
              opacity: 1
            }} exit={{
              scale: 0.6,
              opacity: 0
            }} transition={{
              duration: 0.18,
              ease
            }} className="absolute right-0.5 top-0.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-gold px-1 text-[10px] font-semibold text-paper" data-id="element-123" data-mp="1f2trtvcw5and">
                  {count}
                </motion.span>}
            </AnimatePresence>
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-124" data-mp="2cxml2f4dxgp5">{mega && <MegaMenu data-id="element-125" data-mp="2gygajcxh73k5" />}</AnimatePresence>
      <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-126" data-mp="2gypyyw2vh2nq" />
    </header>;
}